export enum ReviewerRoleEnum {
    DM = 'Delivery Manager',
    PM = 'Project Manager',
    TL = 'Team Lead',
    TEAM = 'Team',
    SELF = 'Self'
}